<template>
<div>
    <div class="h-crumbOut">
        <div class="h-crumbs">
            <el-breadcrumb separator="|">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a href="/xiangmu/pm">项目管理</a></el-breadcrumb-item>
                <el-breadcrumb-item><a href="/">修改中标信息</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
	</div>
    <div class="bigDiv">
        <div class="h-piece">
            <div class="top">
                <div class="h-pieceTitle2">
                    <h1>项目信息</h1>
                    <img v-if="formLabelAlign.isSuccess==0" src="../../../assets/images/pimg/wei.jpg" alt="">
                    <img v-if="formLabelAlign.isSuccess==1" src="../../../assets/images/pimg/zhongbiao.jpg" alt="">
                </div>
                <div class="pieceCon ccc">
                    <div class="h-pieceCon2">
                        <div class="l_one">
                            <el-form :model="formLabelAlign" label-position="right" :rules="rules" ref="formLabelAlign1" :inline="true"  class="demo-ruleForm h-formbLine">
                                <el-form-item label="项目名称" class="h-elformWrap-1" prop="projectName" >
                                    <el-input readonly v-model="formLabelAlign.projectName" placeholder="请输入项目名称" class="h-input"></el-input>
                                </el-form-item>
                            <el-form-item label="项目说明" class="h-elformWrap-1" prop="projectDescription" >
                                <el-input readonly v-model="formLabelAlign.projectDescription" style=" padding-bottom:13px;" placeholder="请输入项目说明"></el-input>
                            </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="n-hu"> 
                <div class="h-pieceTitle2" >
                    <h1>用户信息</h1>
                </div>
                <div class="pieceCon n-bu">
                    <div class="h-pieceCon2">
                        <div class="h-formLine">
                            <el-form :model="formLabelAlign" label-position=right :rules="rules" ref="formLabelAlign2" :inline="true"  class="demo-ruleForm h-formbLine">
                                <el-form-item label="客户名称" class="h-elformWrap-2" prop="customerName">
                                    <el-select v-model="formLabelAlign.customerName"
                                        placeholder="--选择--"
                                        filterable
                                        disabled
                                        @change="changeCustomer"
                                        >
                                        <el-option
                                            v-for="(item,index) in optionsCustomer"
                                            :key="index"
                                            :label="item.userName"
                                            :value="item.userCode">
                                    </el-option>
                                </el-select>
                        </el-form-item>
                        <el-form-item label="区域" class="h-elformWrap-2" prop="projectArea">
                            <el-input v-model="formLabelAlign.projectArea" placeholder="根据客户自动带出" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="客户渠道" class="h-elformWrap-2" prop="customerChannel">
                            <el-input v-model="formLabelAlign.customerChannel" placeholder="根据客户自动带出" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="部门科室" class="h-elformWrap-2" prop="customerDept">
                            <el-input v-model="formLabelAlign.customerDept" placeholder="根据客户自动带出" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="关键人" class="h-elformWrap-2" prop="keyPerson">
                            <el-input v-model="formLabelAlign.keyPerson" placeholder="根据客户自动带出" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" class="h-elformWrap-2 " prop="keyPersonTel">
                            <el-input v-model="formLabelAlign.keyPersonTel" placeholder="根据客户自动带出" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="预计转化日期"  class="h-elformWrap-2" prop="expectConvertDate">
                            <template>
                                <div class=" block"> 
                                    <el-date-picker
                                        disabled
                                        v-model="formLabelAlign.expectConvertDate"
                                        type="date"
                                        placeholder="--选择--"
                                        value-format="yyyy-MM-dd" 
                                        :clearable=false
                                    >
                                    </el-date-picker>
                                </div>
                            </template>
                        </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            </div>
            <div class="N-chan">
                <div class="h-pieceTitle2">
                    <h1>产品信息</h1>
                </div>
                <div class="h-pieceCon2"> 
                    <el-table
                        ref="multipleTable"
                        :data="proProduct"
                        style="width: 100%"
						:border="true"
                        >
                        <el-table-column
                        type="index"
                        width="40"
                        label="#">
                        </el-table-column>
                        <el-table-column
                        prop="typeName"
						:show-overflow-tooltip="true"
                        label="产品大类">
                        </el-table-column>
                        <el-table-column
                        prop="productName"
						:show-overflow-tooltip="true"
                        label="产品型号">
                        </el-table-column>
                        <el-table-column
                        prop="productPrice"
                        label="供货价格"
                        width="200">
                        </el-table-column>
                        <el-table-column
                        prop="productNum"
                        label="产品数量"
                        width="200">
                        </el-table-column>              
                    </el-table>
                </div>
            </div>

                <hr/>
                <div class="whether">
                    <span class="whetherTitle">是否中标</span>
                    <template>
                        <el-radio-group v-model="formLabelAlign.isSuccess" >
                        <el-radio  :label=2>未发布</el-radio>
                        <el-radio  :label=1>中标</el-radio>
                        <el-radio  :label=0>丢标</el-radio>
                        </el-radio-group>
                    </template>
                </div>
                <div class="h-formLine product" v-if="formLabelAlign.isSuccess==0||formLabelAlign.isSuccess==1">
                    <div>
                        <h7 v-if="formLabelAlign.isSuccess==1" style="margin-left:-7px;">中标信息</h7>
                        <h7 v-if="formLabelAlign.isSuccess==0" style="margin-left:-7px;">丢标信息</h7>
                        <br> 
                        <el-form :model="proBidInfo" label-position="right"  ref="proBidInfo" :inline="true"  class="demo-ruleForm h-formbLine form">
                        <el-form-item label="投标金额" class="h-elformWrap-2 Z-biao" prop="bidTotal">
                            <el-input v-model="proBidInfo.bidTotal" placeholder="请输入投标金额" type="number"></el-input>
                            <span class="Z-yuan">万元</span> 
                        </el-form-item>
                        <div class="hetong" v-if="formLabelAlign.isSuccess==1">   
                            <el-row >
                                <el-col :span="12">
                                    <span style="font-size:14px;">合同编码</span>
                                </el-col>
                                <el-col :span="12">
                                    <el-button style="padding:5px 15px;background-color:rgb(16, 145, 231);color:white; border:1px solid rgb(16, 145, 231)">关联合同</el-button>
                                </el-col>
                            </el-row>
                        </div>
                        <!-- <el-form-item label="中标公司" class="h-elformWrap-2 Z-biao" prop="successComp" v-if="formLabelAlign.isSuccess==0">
                            <el-input v-model="proBidInfo.successComp" placeholder="20"></el-input> 
                        </el-form-item>
                        <el-form-item label="丢标金额" class="h-elformWrap-2 Z-biao" prop="failTotal" v-if="formLabelAlign.isSuccess==0">
                            <el-input v-model="proBidInfo.failTotal" placeholder="20"></el-input>
                            <span class="Z-yuan">万元</span>  
                        </el-form-item>
                        <el-form-item label="丢标原因" class="h-elformWrap-2 Z-biao" prop="failReason" v-if="formLabelAlign.isSuccess==0">
                            <el-input v-model="proBidInfo.failReason" placeholder="20"></el-input>
                        </el-form-item> -->
                        </el-form>
                    </div>
                    <div class="h-formLine product zhongT" v-if="formLabelAlign.isSuccess==1">
                        <el-form :model="proBidInfo" label-position="right"  ref="proBidInfo" :inline="true"  class="demo-ruleForm h-formbLine">
                            <el-form-item label="其他投标品牌" class="h-elformWrap-2" prop="otherBrand">
                                <el-input v-model="proBidInfo.otherBrand" placeholder="请输入其他投标品牌" ></el-input>
                            </el-form-item>
                            <el-form-item label="其他投标公司" class="h-elformWrap-2 " prop="otherComp">
                                <el-input v-model="proBidInfo.otherComp" placeholder="请输入其他投标公司" ></el-input>
                                
                            </el-form-item>
                            <el-form-item label="其他公司投标总额" class="h-elformWrap-2" prop="otherTotal">
                                <el-input v-model="proBidInfo.otherTotal" placeholder="请输入其他公司投标总额" type="number"></el-input>
                                <span class="yuan">万元</span>
                            </el-form-item>
                        </el-form>
                        <!-- <img src="../../../assets/images/pimg/jianhao.png" alt="" class="imgJ"> -->
                    </div>
                    <div class="h-formLine product zhongT" v-if="formLabelAlign.isSuccess==0">
                        <el-form :model="proBidInfo" label-position="right"  ref="proBidInfo" :inline="true"  class="demo-ruleForm h-formbLine">
                            <el-form-item label="中标公司" class="h-elformWrap-2" prop="successComp">
                                <el-input v-model="proBidInfo.successComp" placeholder="请输入中标公司" ></el-input>
                            </el-form-item>
                            <el-form-item label="丢标金额" class="h-elformWrap-2 " prop="failTotal" type="number">
                                <span class="yuan">万元</span>

                                <el-input v-model="proBidInfo.failTotal" placeholder="请输入丢标金额" type="number"></el-input>
                            </el-form-item>
                            <el-form-item label="丢标原因" class="h-elformWrap-2" prop="failReason">
                                <el-input v-model="proBidInfo.failReason" placeholder="请输入丢标原因" type="number"></el-input>
                            </el-form-item>
                        </el-form>
                        <!-- <img src="../../../assets/images/pimg/jiahao.png" alt="" class="imgA"> -->
                    </div>
                </div>
                <!-- 用户在用产品信息 -->
                <template>
                <div>
                    <div class="h-pieceIn2">
                        <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                        <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                            <h1>用户在用产品信息</h1>
                        </div>
                        <div class="h-pieceCon2">
                            <div class="h-formLine sponsore" style="margin-bottom:50px;">
                                <div class="categoryBox">
                                    <div class="category" :class="{'active':item==categorys}"
                                            @click="selectC(item)" v-for="(item,index) in category"
                                            :key="index">{{item}}
                                    </div>
                                </div>
                                <div v-if="categorys == '海尔产品'" style="margin-top:20px;">
                                    <el-table
                                        ref="multipleTable"
                                        :data="productInfosHaier"
                                        style="width: 100%"
										:border="true"
                                        >
                                        <el-table-column
                                        type="index"
                                        width="40"
                                        label="#">
                                        </el-table-column>
                                        <el-table-column
                                        prop="category"
                                        label="产品大类"
                                        width="150">
                                            <template scope="scope">
                                                <el-select v-model="scope.row.category"
                                                    placeholder="请先选择产品大类"
                                                    filterable
                                                    @change="changeBigHaierBig(scope.row,scope.$index)"
                                                    class="h-tableInput"
                                                    >
                                                <el-option
                                                        v-for="(item,index) in optionsProductBig"
                                                        :key="index"
                                                        :label="item.levelname"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="specification"
                                        label="产品型号"
                                        width="150">
                                            <template scope="scope">
                                                <el-select v-model="scope.row.specification"
                                                    placeholder="请先选择产品型号"
                                                    filterable
                                                    class="h-tableInput"
                                                    >
                                                <el-option
                                                        v-for="(item,index2) in optionsProductHaier[scope.$index]"
                                                        :key="index2"
                                                        :label="item.levelname"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="amount"
                                        label="产品数量"
                                        width="100">
                                            <template scope="scope">
                                                <el-input v-model="scope.row.amount" class="h-tableInput" placeholder="请输入"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="barCode"
                                        label="条形码"
                                        width="150">
                                            <template scope="scope">
                                                <el-input v-model="scope.row.barCode" class="h-tableInput" placeholder="请输入"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="isOverdue"
                                        label="是否超限期使用"
                                        width="150">
                                            <template scope="scope">
                                                <brselect category="isOverdue" class="h-tableInput" :v="scope.row.isOverdue" v-model="scope.row.isOverdue"
                                        placeholder="--请选择--"></brselect>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="exfactoryDate"
                                        label="出厂日期"
                                        width="150">
                                            <template scope="scope">
                                                <div class="block" >
                                                <el-date-picker
                                                v-model="scope.row.exfactoryDate"
                                                type="date"
                                                placeholder="--选择--"
                                                value-format="yyyy-MM-dd"
                                                class="h-tableInput"
                                                :clearable="false"
                                                style="width:140px"
                                                >
                                                </el-date-picker>
                                            </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="purchaseDate"
                                        label="购买日期"
                                        width="150">
                                            <template scope="scope">
                                                <div class="block">
                                                <el-date-picker
                                                v-model="scope.row.purchaseDate"
                                                type="date"
                                                placeholder="--选择--"
                                                value-format="yyyy-MM-dd"
                                                class="h-tableInput"
                                                :clearable="false"
                                                style="width:140px"
                                                >
                                                </el-date-picker>
                                            </div>
                                            </template>
                                        </el-table-column>
                                        <!-- <el-table-column
                                            label="产品照片"
                                            width="150">
                                            <template slot-scope="scope">
                                                <brupload
                                                :refid = scope.row.id
                                                :reftype = "jingpinHaier"
                                                uploadflag
                                                delflag
                                                >
                                                <el-button size="small" type="text">上传</el-button>
                                                </brupload>
                                            </template>
                                        </el-table-column> -->
                                        <el-table-column
                                        prop="remark"
                                        label="备注"
                                        width="300">
                                            <template scope="scope">
                                                <el-input class="h-tableInput" v-model="scope.row.remark" placeholder="请输入"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="操作"
                                            width="100"
                                            fixed="right">
                                            <template slot-scope="scope">
                                                <el-button type="text" size="small" @click="delUserProduction1(scope.$index)">删除</el-button>
												<!-- <div class="l-operationBox">
													<span class="l-operationlist br-operation-delete" title="删除该条" @click="delUserProduction1(scope.$index)"></span>
												</div> -->
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div class="h-tableAdd" @click="addHaier">
                                        <a>新增在用海尔产品</a>
                                    </div>
                                </div>
                                <div v-if="categorys == '竞品'" style="margin-top:20px;">
                                    <el-table
                                        ref="multipleTable"
                                        :data="productInfosOther"
                                        style="width: 100%"
										:border="true"
                                        >
                                        <el-table-column
                                        type="index"
                                        width="40"
                                        label="#">
                                        </el-table-column>
                                        <el-table-column
                                        prop="category"
                                        label="产品大类"
                                        width="150">
                                            <template scope="scope">
                                                <el-select v-model="scope.row.category"
                                                        placeholder="请先选择产品大类" 
                                                        filterable
                                                        class="h-tableInput"
                                                        >
                                                    <el-option
                                                            v-for="(item,index) in optionsProductBig"
                                                            :key="index"
                                                            :label="item.levelname"
                                                            :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="brand"
                                        label="产品品牌"
                                        width="150">
                                            <template scope="scope">
                                                <el-input v-model="scope.row.brand" class="h-tableInput" placeholder="请填写产品型号"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="specification"
                                        label="产品型号"
                                        width="150">
                                            <template scope="scope">
                                                <el-input v-model="scope.row.specification" class="h-tableInput" placeholder="请填写产品型号"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="amount"
                                        label="产品数量"
                                        width="100">
                                            <template scope="scope">
                                                <el-input v-model="scope.row.amount" class="h-tableInput" placeholder="请输入"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="barCode"
                                        label="条形码"
                                        width="150">
                                            <template scope="scope">
                                                <el-input v-model="scope.row.barCode" class="h-tableInput" placeholder="请填写产品数量"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="isOverdue"
                                        label="是否超限期使用"
                                        width="150">
                                            <template scope="scope">
                                                <brselect category="isOverdue" class="h-tableInput" :v="scope.row.isOverdue" v-model="scope.row.isOverdue"
                                        placeholder="--请选择--"></brselect>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="exfactoryDate"
                                        label="出厂日期"
                                        width="150">
                                            <template scope="scope">
                                                <div class="block">
                                                    <el-date-picker
                                                    v-model="scope.row.exfactoryDate"
                                                    type="date"
                                                    class="h-tableInput"
                                                    placeholder="--选择--"
                                                    value-format="yyyy-MM-dd"
                                                    :clearable=false >
                                                    </el-date-picker>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="purchaseDate"
                                        label="购买日期"
                                        width="150">
                                            <template scope="scope">
                                                <div class="block">
                                                    <el-date-picker
                                                    v-model="scope.row.purchaseDate"
                                                    class="h-tableInput"
                                                    type="date"
                                                    placeholder="--选择--"
                                                    value-format="yyyy-MM-dd"
                                                    :clearable=false>
                                                    </el-date-picker>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <!-- <el-table-column
                                            label="产品照片"
                                            width="150">
                                            <template slot-scope="scope">
                                                <brupload
                                                :refid = scope.row.id
                                                :reftype = "jingpinOther"
                                                uploadflag
                                                delflag
                                                >
                                                <el-button size="small" type="text">上传</el-button>
                                                </brupload>
                                            </template>
                                        </el-table-column> -->
                                        <el-table-column
                                        prop="remark"
                                        label="备注"
                                        width="300">
                                            <template scope="scope">
                                                <el-input v-model="scope.row.remark" class="h-tableInput" placeholder="请输入"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="操作"
                                            width="100">
                                            <template slot-scope="scope">
												<el-button type="text" size="small"  @click="delUserProduction2(scope.$index)">删除</el-button>
												<!-- <div class="l-operationBox">
													<span class="l-operationlist br-operation-delete" title="删除该条" @click="delUserProduction2(scope.$index)"></span>
												</div> -->
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div class="h-tableAdd" @click="addComp">
                                        <a>新增在用竞品产品</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div style="display: flex;justify-content:center;margin-top:20px">
            <el-row>
                <el-button class="h-btn h-bBtn h-bgwhite"  @click="cancelPro">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblue2" @click="submitPro()">确认提交</el-button>
            </el-row>
        </div>  
        </div>
    </div>
</template>

<style scoped>
    .Z-yuan{
        position: absolute;
        left: 90%;
    }
    .yuan{
        position: absolute;
        left: 85%;
    }
    .n-bu .h-formbLine .h-elformWrap-2,
    .n-chan .h-formbLine .h-elformWrap-2,
    .n-j .h-formbLine .h-elformWrap-2{
        width: 33.333%;
    }
    .pieceCon, .product{
        width: 92%;
        padding-top: 20px;
        margin-left: 15px;
    }
    h1{
        margin-left: 11px;
    }
    img{
        width: 30px;
        position: relative;
        left: 15rem;
    }
    .N-chan .h-pieceTitle2,.n-hu .h-pieceTitle2{
        margin: 25px;
        margin-left: 0;
    }
    .zui{
        margin-top: -30px;
    }
</style>
<style>
    .l_one .h-formbLine .el-form-item__label{
        width: 12%;
    }
    .l_one .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 87.8%;
    }
    
     .whetherTitle{
        margin-right: 20px;
    }
   
    .zhongT{
        margin-bottom: 20px;
        background-color: rgb(249, 251, 252);
        border: 1px solid rgb(206, 204, 204);
    }
    .Z-biao{
        margin-left: 15px;
        margin-top: 15px;
    }
    .hetong{
        display: inline-block;
        margin-top: 13px;
    }
   
    .zhongT .h-formbLine .el-form-item__content,
    .n-bu .h-formbLine .el-form-item__content,
    .n-j .h-formbLine .el-form-item__content
    {
        width: 57%;
    }
    
    .zhongT .h-formbLine .el-form-item__label,
    .n-bu .h-formbLine .el-form-item__label,
    .n-j .h-formbLine .el-form-item__label
    { 
        width: 43%;
    }
   .bigDiv{
       margin: 20px;
   }
    h7{
        padding-left: 23px;
        color: rgb(72, 144, 226)
    }
    hr{
        background-color: rgb(238, 234, 234);
        height: 1px;
        margin: 30px 65px 30px 12px;
        border: none;
    }
    .whether{
        font-size: 13px;
        margin-left: 31px;
        padding-bottom: 20px;
    }
   .h-formbLine .h-elformWrap-2.shujzidan .el-form-item__content .el-select{
       width: 100%!important;
   }
   .h-formbLine .h-elformWrap-2.lll .el-form-item__content .el-select{
       width: 100%!important;
   }
</style>
<script>
import ss from '../../../api/SystemService';
export default {
    data(){
      return{
        proBidInfo:{},
        formInline: {},
        formLabelAlign: {type:3,isSuccess:"2",proBidInfoList:[]},
        value1:'',
        optionsCustomer: [],
        //产品信息
        proProduct: [{productPrice:'',type:'',productId:''}],
        //产品大类选项
        optionsProduct1: [],
        //产品小类选项
        optionsProduct2: [],
        optionsArea: [],
        customeInfo: {},
        projectId:'',
        //竞品使用
        //带线表单
        categorys: '海尔产品',
        category: ['海尔产品', '竞品'],
        //附件类别
        jingpinOther:"jingpinOther",
        jingpinHaier:"jingpinHaier",
        //产品大类选项
        optionsProductBig: [],
        //产品小类选项
        optionsProductHaier: [{}],
        //海尔产品竞品
        productInfosHaier: [{id:1,type:1,fromType:1,specification:'',brand:"Haier"}],
        //其他品牌产品竞品
        productInfosOther: [{id:2,type:2,fromType:1,}],
        rules:{
           projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur'}],
           projectDescription: [{ required: true, message: '请输入项目说明', trigger: 'blur'}],
           customerName: [{ required: true, message: '请选择客户', trigger: 'change'}],
           projectArea: [{ required: true, message: '根据客户自动带出', trigger: 'blur'}],
           customerChannel: [{ required: true, message: '根据客户自动带出', trigger: 'blur'}],
           customerDept: [{ required: true, message: '根据客户自动带出', trigger: 'blur'}],
           keyPerson: [{ required: true, message: '根据客户自动带出', trigger: 'blur'}],
           keyPersonTel: [{ required: true, message: '根据客户自动带出', trigger: 'blur'}],
           expectConvertDate: [{ required: true, message: '请选择转化日期', trigger: 'change'}],
           type: [{ required: true, message: '请选择产品大类', trigger: 'change'}],
           productId: [{ required: true, message: '请先选择产品大类后选择产品型号', trigger: 'change'}],
           productPrice: [{ required: true, message: '根据产品型号自动带出', trigger: 'change'},
                        { type: 'number', message: '必须为数字值'}
                        ],
           productNum: [{ required: true, message: '请输入产品数量', trigger: 'blur'},
                        { type: 'number', message: '必须为数字值'}],
           }
      }
    },
    mounted() {
        this.selectCustomer();
        this.selectProduct1();
        this.selectBidInfo();
        this.query();
        //竞品使用
        this.selectProductBig();
    },
    methods: {
        selectBidInfo() {
            ss.ProService.bidInfo(this.$route.query.id).then(rd => {
                //console.log("客户名称下拉", rd)
                if(rd&&rd.length>0){
                    this.proBidInfo=rd[0];
                }
            })
        },
        delIndex(index){
            this.proProduct.splice(index, 1)
            //console.log(index,"删除一行数据");
        },
        //增加海尔产品方法
        //增加产品方法
        adds(){
            var a = {productPrice:'',productId:''}
            this.proProduct.push(a)
        },
        selectCustomer() {
            ss.ProService.customerSelect().then(rd => {
                // console.log("客户名称下拉", rd)
                this.optionsCustomer = rd;
            })
        },
        selectProduct1() {
            ss.ProService.product1Select().then(rd => {
                // console.log("产品大类下拉", rd)
                this.optionsProduct1 = rd;
            })
        },
        //大类修改时，当块数据proProduct[i]-v,index-i
        changeBig(v,i){
            v.productId='';
            v.productPrice='';
            //console.log("选中大类v.productId222",v,i);
            this.selectProduct2(v.type,i);
        },
        //大类修改时，查询小类列表 v.type大类id-v,index-i
        selectProduct2(v,i) {
            //console.log("3选中大类222",v,i);
            ss.ProService.product2Select(v).then(rd => {
                //console.log("4产品小类下拉", rd)
                //console.log("40产品小类下拉", this.optionsProduct2[i])
                this.optionsProduct2[i] = rd;
                this.$set(this.optionsProduct2,i,rd);
                //console.log(this.optionsProduct2[i],"5产品小类下拉", this.optionsProduct2)
            })
        },
        //小类修改，当块数据proProduct[i]-v 
        changeSmail(v) {
            //this.$set(v,"productId",v.productId)
            //v.productId=v.productId;
            var data={mdmMaterialInfoPrice:{materialid:v.productId,leltypecode:1,type:"03",currency:"CNY"}}
            console.log("选中信息2", data)
            ss.ProService.product2Detail(data).then(rd => {
                console.log("选中信息1", 12)
                if(rd.obj&&rd.obj.length>0){  
                     console.log("1产品小类详情", rd);                  
                    v.productPrice=rd.obj[0].mdmMaterialInfoPrice.value;
                }else{
                     //console.log("22产品小类详情", rd);
                    v.productPrice=null;
                }
            })
        },
        changeCustomer(c) {
            console.log("选中信息2", c)
            this.optionsCustomer.forEach((item, index) => {
                if(c==item.userCode){
                    console.log("选中信息2", item)
                    this.formLabelAlign.customerId =item.userCode;
                    this.formLabelAlign.customerName =item.userName;
                    this.formLabelAlign.keyPerson =item.contactuserName;
                    this.formLabelAlign.keyPersonTel =item.telephone;
                    this.formLabelAlign.customerDept=item.department;
                    this.formLabelAlign.projectArea=this.$getDictName("areaLittle",item.areaCode);
                    this.formLabelAlign.customerChannel=this.$getDictName("qu_dao",item.channelCode);
                    if(item.userType&&item.userType==1){
                        this.formLabelAlign.userType=1
                    }else{
                        this.formLabelAlign.userType=2
                    }
                }
            })
        },
        submitPro(){ 
            //console.log("保存项目信息", this.formLabelAlign);
            //合并海尔的竞品和其他品牌的竞品
                this.productInfosHaier.forEach((item,index) =>{
                    if(item.category){
                        item.fromId=this.productId;
                        this.formLabelAlign.userProductInfoList.push(item);
                    }
                })
                this.productInfosOther.forEach((item,index) =>{
                    if(item.category){
                        item.fromId=this.productId;
                        this.formLabelAlign.userProductInfoList.push(item);
                    }
                })

                if(this.formLabelAlign.isSuccess!=2){
                    this.proBidInfo.isSuccess=this.formLabelAlign.isSuccess;
                    this.formLabelAlign.proBidInfoList=[this.proBidInfo];
                }
                console.log("保存项目信息",this.formLabelAlign)
                if(this.formLabelAlign.isSuccess==0){
                    ss.ProService.saveBidLoss(this.formLabelAlign).then(rd => {
                        this.$msg.msgs("保存！");
                        this.$router.push("/xiangmu/pm");
                        //console.log("保存项目信息", rd)
                    })
                }
                if(this.formLabelAlign.isSuccess==1){
                    ss.ProService.saveBidWin(this.formLabelAlign).then(rd => {
                        this.$msg.msgs("保存！");
                        this.$router.push("/xiangmu/pm");
                        //console.log("保存项目信息", rd)
                    })
                }
                if(this.formLabelAlign.isSuccess==2){
                    this.$msg.msge("请完善中标信息！");
                }
                

        },
        //需求一键转化项目
        query(){
            console.log(this.$route.query.id,"111111111");
            ss.ProService.proDetail(this.$route.query.id).then(rd => {
                console.log(rd, "项目列表");
                this.formLabelAlign = rd;
                //客户信息赋值
                this.changeCustomer(this.formLabelAlign.customerId);
                if(rd.proProductInfoList&&rd.proProductInfoList.length>0){
                    this.proProduct=rd.proProductInfoList;
                    if(rd.userProductInfoHaierList&&rd.userProductInfoHaierList.length>0){
                        this.productInfosHaier=rd.userProductInfoHaierList;
                    }
                    if(rd.userProductInfoOtherList&&rd.userProductInfoOtherList.length>0){
                        this.productInfosOther=rd.userProductInfoOtherList;
                    } 
                }
            });
        },
        cancelPro(){
            this.$router.push("/xiangmu/pm");
        },
        //竞品使用
        selectC(item) {
            this.categorys = item;
            console.log(this.categorys)
        },
        delUserProduction1(index){
            this.productInfosHaier.splice(index, 1)
            //console.log(index,"删除一行数据");
        },
        delUserProduction2(index){
            this.productInfosOther.splice(index, 1)
            //console.log(index,"删除一行数据");
        },
        addComp(){
            var id = this.$util.getUuid();
            console.log(id,"----------------");
            var a = {id:id,type:2,fromType:1}
            console.log(a,"----------------");
            this.productInfosOther.push(a)
        },
        addHaier(){
            var id = this.$util.getUuid();
            var a = {id:id,type:1,fromType:1,specification:'',brand:"Haier"}
            this.productInfosHaier.push(a)
        },
        //大类修改时，当块数据proProduct[i]-v,index-i
        changeBigHaierBig(v,i){
            //console.log("1选中大类",v);
            v.specification='';
            //console.log("2选中大类v.productId222",v,i);
            this.selectProductHaier(v.category,i);
        },
        //海尔内部竞品，大类修改时，查询小类列表 v.type大类id-v,index-i
        selectProductHaier(v,i) {
            //console.log("3选中大类222",v,i);
            ss.ProService.product2Select(v).then(rd => {
                //console.log("4产品小类下拉", rd)
                this.optionsProductHaier[i] = rd;
                this.$set(this.optionsProductHaier,i,rd);
                //console.log(this.optionsProductHaier[i],"5产品小类下拉", this.optionsProductHaier)
            })
        },
        selectProductBig() {
            ss.ProService.product1Select().then(rd => {
                console.log("产品大类下拉", rd)
                this.optionsProductBig = rd;
            })
        },    
    },
}
</script>

<style scoped>
.categoryBox {
    display: flex;
    border-bottom: 1px solid #dcdfe1;
}

.categoryBox .category {
    width: 122px;
    height: 36px;
    color: #b0b0b0;
    font-size: 0.2rem;
    text-align: center;
    line-height: 36px;
    margin-left: 20px;
    border: 1px solid #b4b4b4;
    cursor: pointer;
    border-bottom: 0;
}
.categoryBox .category:first-child{
    margin-left: 0;
}
.categoryBox .category.active {
    color: #fff;
    border: 1px solid #0e75e9;
    background: #0e75e9;
}
</style>
<style>
.sponsore .h-formbLine .el-form-item__label{
	width: 31%;
	text-align: right;
}
.sponsore .h-formbLine .el-form-item__content{
	width: 69%;
}
.sponsore .h-formbLine .h-elformWrap-2{
	width: 33.333%;
	padding-right: 0.5rem
}
.sponsore .h-formbLine .h-elformWrap-1{
	width: 100%;
	padding-right: 0.5rem
}
.sponsore .h-formbLine .h-elformWrap-1 .el-form-item__label{
	width: 9.7%;
}
.sponsore .h-formbLine .h-elformWrap-1 .el-form-item__content{
	width: 90.3%;
}
</style>

